import { Radio, RadioProps } from '@components/radio/radio';
import { FieldProps } from 'formik';

export const FormRadio = ({ field, form, ...props }: RadioProps & FieldProps) => {
	return <Radio {...field} {...props} />;
};
